module.exports = __webpack_public_path__ + "static/media/data-trends.80483908.svg";